var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-loading',{attrs:{"loading":_vm.versionMeta.loading}},[_c('version-form',{attrs:{"version":Object.assign({}, {gameId: _vm.selectedGameId}, _vm.version),"mode":"edit"},on:{"submit":_vm.handleSubmit,"delete":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }